export const handleApiError = (error) => {
    if (error.code === 'ECONNABORTED') {
        return { errors: ["Request timed out"], status: "ECONNABORTED" };
    } else if (error?.response?.data) {
        return error.response.data;
    } else {
        return { errors: [error.message], status: error.code || "UNKNOWN_ERROR" };
    }
};